module.exports = __webpack_public_path__ + "img/backgroundImg2.7398110e.svg";